
export { default as Image } from "./Atoms/Image"